import { type ReactNode } from "react"

interface ISelectOption {
    id: string
    label: string
    value: string | ReactNode
    isDisabled?: boolean
}

enum ESelectVariant {
    Default = "default"
}

enum ESelectSize {
    _210 = "_210",
    Medium = "medium",
    Full = "full"
}

type TPropsShared = {
    variant?: ESelectVariant
    size?: ESelectSize
    isDisabled?: boolean
    isLoading?: boolean
    isError?: boolean
    label?: string
    defaultValue?: string
    options: ISelectOption[]
    onChange(value: string): void
    placeholder?: string
    wrapperClassName?: string
}

type TSelectOnOpenChangeFunction = (id: string, isOpen: boolean) => void

type TSelectProps =
    | (TPropsShared & {
          withFixedContainer?: never
          maxHeight?: never
          id?: never
          onOpenChange?: never
      })
    | (TPropsShared & {
          withFixedContainer: true
          maxHeight: number
          id: string
          onOpenChange?: TSelectOnOpenChangeFunction
      })

export { type ISelectOption, type TSelectProps, type TSelectOnOpenChangeFunction, ESelectVariant, ESelectSize }
